import { createSlice } from '@reduxjs/toolkit';

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState: {
    processedAnalytics: {
      usersOnline: 0,
      events: [],
    },
    userActivity: [],
  },
  reducers: {
    addEvent(state, action) {
      const newEvent = action.payload;

      // Deduplicate based on eventId
      const isDuplicate = state.processedAnalytics.events.some(
        (event) => event.eventId === newEvent.eventId
      );
      if (isDuplicate) return;

      // Ensure state is updated immutably
      state.processedAnalytics = {
        ...state.processedAnalytics,
        events: [newEvent, ...state.processedAnalytics.events].slice(0, 50),
        usersOnline: new Set([newEvent.hash, ...state.processedAnalytics.events.map(e => e.hash)]).size
      };
    },

    updateUserActivity(state, action) {
      const timestamp = Date.now();
      const fiveSecondBucket = Math.floor(timestamp / (1000 * 5));
      const existingActivity = state.userActivity.find(
        (activity) => Math.floor(activity.timestamp / (1000 * 5)) === fiveSecondBucket
      );

      if (existingActivity) {
        existingActivity.count += 1;
      } else {
        state.userActivity.push({ count: 1, timestamp });
      }

      // Keep activity for only the last 60 seconds
      state.userActivity = state.userActivity.filter(
        (activity) => timestamp - activity.timestamp < 60000
      );
    },
  },
});

export const { addEvent, updateUserActivity } = analyticsSlice.actions;
export default analyticsSlice.reducer;
